module.exports = __webpack_public_path__ + "static/media/thumb.b44b27aa.jpg";